import { APICore } from './apiCore';

const api = new APICore();

function forgotPassword(params: { username: string }) {
    const baseUrl = '/v2/user/request-reset-password';
    params.username = params.username?.toLowerCase();
    return api.create(`${baseUrl}`, params);
}

function refreshAccessToken(params: { refreshToken: string }) {
    const baseUrl = `/oauth/access_token?grant_type=refresh_token&refresh_token=${params.refreshToken}`;
    return api.create(baseUrl, {});
}

export { forgotPassword, refreshAccessToken };
